<div class="filters-container">
  <div class="field-container">
    <div class="icon-container">
      <mat-form-field color="accent">
        <mat-label>{{sysText.search}}</mat-label>
        <mat-icon matSuffix class="suffix-icon">search</mat-icon>
        <input matInput [formControl]="searchValue" (keyup)="applySearch($event)" #input autocomplete="off">
      </mat-form-field>
      <!-- a button so keyboard users can reach the search tips too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="sysText.moreInformation_ariaLabel"
        [matTooltip]="sysText.search_info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="right">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    </div>
    <app-select-field
      class="field"
      [control]="employerControl"
      [label]="sysText.owner"
      [options]="emailTemplatesData.ownerFilterOptions"
      [shouldCapitalize]="false"
      [showBlankOption]="true"
      [showHintArea]="false"
      [hideIconSpace]="true">
    </app-select-field>
  </div>

  <div class="button-container">
    <!-- on mobile this shows only its icon, so its label names it there (a tooltip isn't a name). it keeps focus while
    loading: showProgress lays the spinner over its content, disabledInteractive keeps it focusable, and the guard blocks
    clicks -->
    @let isLoading = isLoadingAddEditDocumentCategoryDialog$ | async;
    @let loadingAdd = isLoading && loadingAction === 'add';
    <button
      mat-stroked-button
      class="button button-height"
      color="accent"
      [disabled]="isLoading"
      disabledInteractive
      [showProgress]="loadingAdd"
      (click)="!isLoading && onCreateNew()"
      [attr.aria-label]="loadingAdd ? sysText.loading_ariaLabel : (isMobile ? (sysText.addNewCategory | capitalizefirst) : null)"
      [matTooltip]="isMobile ? (sysText.addNewCategory | capitalizefirst) : null"
      [matTooltipShowDelay]="500"
      matTooltipPosition="above">
      <mat-icon>add</mat-icon>
      @if (!isMobile) {
        <span>{{ sysText.addNewCategory }}</span>
      }
      <mat-spinner progressIndicator diameter="18" color="accent"></mat-spinner>
    </button>
  </div>
</div>

<div class="main-content container make-scroll">
  <table
    mat-table
    [dataSource]="_dc"
    [trackBy]="trackByCategoryId"
    matSort
    id="data-table">

    <!-- Category Name Column -->
    <ng-container matColumnDef="documentCategoryName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ sysText.categoryName }}</span>
      </th>
      <td mat-cell *matCellDef="let dc" [ngClass]="{ smaller: isMobile }">
        <div>
          <button type="button" class="button-reset link" (click)="editCategory(dc)">
            {{ dc.documentCategoryName }}
          </button>
        </div>
      </td>
    </ng-container>

    <!-- Owner Column -->
    <ng-container matColumnDef="ownerEmployer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ sysText.owner | titlecase }}</span>
      </th>
      <td mat-cell *matCellDef="let dc" [ngClass]="{ smaller: isMobile }">
        <div class="chip-container">
          @if (dc.isSystem) {
            <span>
              {{ "-- " + sysText.system + " --" }}
            </span>
          }
          @if (dc.isStock) {
            <span>
              {{ "-- " + sysText.stock + " --" }}
            </span>
          }
          @if (!dc.isSystem && !dc.isStock) {
            <a
              class="link" [routerLink]="'/' + routes.EMPLOYER_PROFILE + '/' + dc.ownerEmployer.employerId">
              {{ dc.ownerEmployer.employerName }}
            </a>
          }
          @if (dc.isOwner) {
            <app-status-chip
              [icon]="'stars'"
              [ngStyle]="chipStyles.successBg"
              [tooltip]="sysText.categoryOwner | titlecase"
              [removeMargin]="true">
            </app-status-chip>
          }
        </div>
      </td>
    </ng-container>

    <!-- Allow Use Column -->
    <ng-container matColumnDef="allowUse">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ sysText.allowUse }}</span>
      </th>
      <td mat-cell *matCellDef="let dc" [ngClass]="{ smaller: isMobile }">
        <span class="chip-container">
          <app-status-icon [isEnabled]="dc.allowUse"></app-status-icon>
          {{dc.allowUse ? (sysText.enabled | titlecase) : (sysText.disabled | titlecase)}}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<mat-paginator
  color="accent"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="changePage($event)"
  [showFirstLastButtons]="pageSizeOptions.length > 1">
</mat-paginator>